import React from "react";
import Container from "@mui/material/Container";

import Header from "./components/general/Header";
import Footer from "./components/general/Footer";

import styles from "./App.module.scss";
import {useRoutes} from "react-router-dom";

import {ThemeProvider} from "@mui/material/styles";
import Theme from "./Theme";
import CssBaseline from "@mui/material/CssBaseline";
import {useKeycloak} from "@react-keycloak/web";
import {routesConfig} from "./routes/RoutesConfig";
import {StyledEngineProvider, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import useRoleAccess from "./hooks/UseRoleAccess";
import {SnackbarProvider} from "notistack";

export default function App() {
  const routesElement = useRoutes(routesConfig);
  const {t} = useTranslation();
  const isAuthenticated = useKeycloak().keycloak.authenticated;
  const isPermitted = useRoleAccess();

  const noAccess = (
    <Container sx={{backgroundColor: "white", marginTop: 5, padding: 2}}>
      <Typography variant="h1">{t("base.noAccess")}</Typography>
    </Container>
  );

  const loading = (
    <Container sx={{backgroundColor: "white", marginTop: 5, padding: 2}}>
      <Typography variant={"h1"}>{t("base.loading")}</Typography>
    </Container>
  );

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={Theme}>
        <CssBaseline />
        <div className={styles.app}>
          <Header />
          <main>
            {isAuthenticated && isPermitted !== undefined ?
              isPermitted ? routesElement : noAccess : loading
            }
          </main>
          <SnackbarProvider />
          <Footer />
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
